import { Chip } from '@mui/material'
import { SmallCard } from 'Components/Cards/Small'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { type programSummary } from 'core/types'

export function AllocationCard (props: { allocationType: programSummary[] }): JSX.Element {
  const badges = props.allocationType.map((at) => {
    const colorItem = at.id % 3
    let indicatorClass = 'cyan-'
    if (colorItem === 1) {
      indicatorClass = 'purple-'
    } else if (colorItem === 2) {
      indicatorClass = 'red-'
    }
    return <Chip key={at.name + indicatorClass + 'allocationicon'} icon={<FiberManualRecordIcon className={indicatorClass + 'icon'} />} label={at.seats} size='small' className={indicatorClass + 'indicator'} />
  })

  return (<SmallCard
    header={'Allocation by Type'}
    totalValue={props.allocationType.reduce((a, b) => a + b.seats, 0)}
    badges={<>{badges}</>} onClick={() => {}}
  />)
}
